import Venue1 from './StadiumComponents/1'
import Venue2 from './StadiumComponents/2'
import Venue3 from './StadiumComponents/3'
import Venue4 from './StadiumComponents/4'
import Venue5 from './StadiumComponents/5'
import Venue7 from './StadiumComponents/7'
import Venue10 from './StadiumComponents/10'
import Venue12 from './StadiumComponents/12'
import Venue13 from './StadiumComponents/13'
import Venue14 from './StadiumComponents/14'
import Venue15 from './StadiumComponents/15'
import Venue17 from './StadiumComponents/17'
import Venue19 from './StadiumComponents/19'
import Venue22 from './StadiumComponents/22'
import Venue31 from './StadiumComponents/31'
import Venue32 from './StadiumComponents/32'
import Venue680 from './StadiumComponents/680'
import Venue2392 from './StadiumComponents/2392'
import Venue2394 from './StadiumComponents/2394'
import Venue2395 from './StadiumComponents/2395'
import Venue2523 from './StadiumComponents/2523'
import Venue2529 from './StadiumComponents/2529'
import Venue2602 from './StadiumComponents/2602'
import Venue2680 from './StadiumComponents/2680'
import Venue2681 from './StadiumComponents/2681'
import Venue2889 from './StadiumComponents/2889'
import Venue3289 from './StadiumComponents/3289'
import Venue3309 from './StadiumComponents/3309'
import Venue3312 from './StadiumComponents/3312'
import Venue3313 from './StadiumComponents/3313'
import Venue4169 from './StadiumComponents/4169'
import Venue4705 from './StadiumComponents/4705'
import Venue5325 from './StadiumComponents/5325'

export default {
    1: Venue1,
    2: Venue2,
    3: Venue3,
    4: Venue4,
    5: Venue5,
    7: Venue7,
    10: Venue10,
    12: Venue12,
    13: Venue13,
    14: Venue14,
    15: Venue15,
    17: Venue17,
    19: Venue19,
    22: Venue22,
    31: Venue31,
    32: Venue32,
    680: Venue680,
    2392: Venue2392,
    2394: Venue2394,
    2395: Venue2395,
    2523: Venue2523,
    2529: Venue2529,
    2602: Venue2602,
    2680: Venue2680,
    2681: Venue2681,
    2889: Venue2889,
    3289: Venue3289,
    3309: Venue3309,
    3312: Venue3312,
    3313: Venue3313,
    4169: Venue4169,
    4705: Venue4705,
    5325: Venue5325,
}
